// extracted by mini-css-extract-plugin
export default {"content":"TextBlock_content__RO6UA"};